// Simple toast notification utility
// This assumes you have a toast component or library set up
// You can customize this based on your preferred notification system

export const showToast = (message, type = 'info', duration = 5000) => {
  // Check if using a toast library like vue-toastification
  if (window.$toast) {
    switch (type) {
      case 'success':
        window.$toast.success(message)
        break
      case 'error':
        window.$toast.error(message)
        break
      case 'warning':
        window.$toast.warning(message)
        break
      default:
        window.$toast.info(message)
    }
    return
  }
  
  // Fallback to native browser notifications or console
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification(message)
  } else {
    // Fallback to console or custom toast implementation
    console.log(`${type.toUpperCase()}: ${message}`)
    
    // Simple custom toast implementation
    createToastElement(message, type, duration)
  }
}

// Custom toast element creator (fallback)
const createToastElement = (message, type, duration) => {
  const toast = document.createElement('div')
  toast.className = `toast toast-${type}`
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${getToastColor(type)};
    color: white;
    padding: 11px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 11px rgba(0,0,0,0.2);
    z-index: 10000;
    max-width: 300px;
    animation: slideIn 0.3s ease;
  `
  
  toast.textContent = message
  
  // Add CSS animation
  const style = document.createElement('style')
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
  `
  document.head.appendChild(style)
  
  document.body.appendChild(toast)
  
  setTimeout(() => {
    toast.style.animation = 'slideOut 0.3s ease'
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast)
      }
      if (style.parentNode) {
        style.parentNode.removeChild(style)
      }
    }, 300)
  }, duration)
}

const getToastColor = (type) => {
  const colors = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  }
  return colors[type] || colors.info
}

export default showToast